/**
 * Created by showzyl on 2017/2/27.
 */

'use strict'

;
(function (win) {
	'use strict'
	
	var defaultClick = 'click';
	win.mv_common = {};

	mv_common.share = function (data) {
		var share_facebook = mv_util.getEl('#share_facebook');
		var share_twitter = mv_util.getEl('#share_twitter');
		// var share_instagram = mv_util.getEl('#share_instagram');

		share_facebook && share_facebook.addEventListener(defaultClick, function () {
			var me = this;
			var u = me.getAttribute('data-url') || window.location.href;
			var action = me.getAttribute('data-action');
			var t = document.title;
			mv_common.gpStats(function () {
				var mv_ga = mv_util.getEl('#mv_ga');
				var param = mv_ga.getAttribute('data-param');
				param = JSON.parse(param);
				console.log(action, param);
				
				if(action){
					ga('set', {
						dimension1: param['offer'],
						dimension2: param['app'],
						dimension3: param['advertiser']
					});
					ga('send', {
						title: t,
						hitType: 'event',
						eventCategory: 'Richmedia', // 'Richmedia'
						eventAction: action, // 'Click_Roll_Banner'
						eventLabel: data.width + '_' + data.height // mv_data.width + mv_data.height
					});
				}
				
			});
			window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t),
				'sharer',
				'toolbar=0,' +
				'status=0,' +
				'width=626,' +
				'height=436'
			);
		})

		share_twitter && share_twitter.addEventListener(defaultClick, function () {
			var me = this;
			var u = me.getAttribute('data-url') || window.location.href;
			var action = me.getAttribute('data-action');
			var t = document.title;
			mv_common.gpStats(function () {
				var mv_ga = mv_util.getEl('#mv_ga');
				var param = mv_ga.getAttribute('data-param');
				param = JSON.parse(param);
				console.log(action, param);

				if(action){
					ga('set', {
						dimension1: param['offer'],
						dimension2: param['app'],
						dimension3: param['advertiser']
					});
					ga('send', {
						title: t,
						hitType: 'event',
						eventCategory: 'Richmedia', // 'Richmedia'
						eventAction: action, // 'Click_Roll_Banner'
						eventLabel: data.width + '_' + data.height // mv_data.width + mv_data.height
					});
				}

			});
			
			window.open('http://twitter.com/home/?status=' + t + ' ' + u);
		})
		
		// share_instagram.onclick = function () {
		// 	var me = this;
		// 	var t = document.title;
		// 	var u = me.getAttribute('data-url');
		// 	window.open('http://twitter.com/home/?status=' + t + ' ' + u);
		// }

	}

	mv_common.stats = function (el) {
		setTimeout(function(){
			for (var i = 0; i < el.length; i++) {
				var url = el[i].getAttribute('data-url');
				if(url){
					mv_util.createEl('script', '', {
						src: url
					})
				}
			}
		},100);
	}

	//cb 回调函数 ua 统计代号
	mv_common.gpStats = function (cb,ua) {
		if(typeof ga === 'undefined'){
			(function (i, s, o, g, r, a, m) {
				i['GoogleAnalyticsObject'] = r;
				i[r] = i[r] || function () {
						(i[r].q = i[r].q || []).push(arguments)
					}, i[r].l = 1 * new Date();
				a = s.createElement(o),
					m = s.getElementsByTagName(o)[0];
				a.async = 1;
				a.src = g;
				m.parentNode.insertBefore(a, m)
			})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
			ga('create', ua || 'UA-26206631-1', 'auto');
			ga('set', 'checkProtocolTask', null); // Disable file protocol checking.
			ga('set', 'checkStorageTask', null); // Disable cookie storage checking.
			ga('set', 'historyImportTask', null); // Disable history checking (requires reading from cookies).
			ga('send', 'pageview'); // 统计`pv`
		}else{
			cb();
		}
	}
	

	/**
	 *  tpl width && height
	 */
	mv_common.getTplSize = function (data) {
		var param = mv_util.getUrlParams();
		// 优先取参数里的宽高
		if( param && param.width && param.height ){
			data.width = param.width;
			data.height = param.height;
		}
		return ((data.width == '320' && data.height == '50') || (data.width == '1200' && data.height == '627'));
	}



})(window);

















